import { render } from "./ReferralConsultationSectionOATSDetails.vue?vue&type=template&id=bde6907c&scoped=true"
import script from "./ReferralConsultationSectionOATSDetails.vue?vue&type=script&lang=js"
export * from "./ReferralConsultationSectionOATSDetails.vue?vue&type=script&lang=js"

import "./ReferralConsultationSectionOATSDetails.vue?vue&type=style&index=0&id=bde6907c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde6907c"],['__file',"src/components/ReferralConsultationSectionOATSDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bde6907c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bde6907c', __exports__)) {
    api.reload('bde6907c', __exports__)
  }
  
  module.hot.accept("./ReferralConsultationSectionOATSDetails.vue?vue&type=template&id=bde6907c&scoped=true", () => {
    api.rerender('bde6907c', render)
  })

}


export default __exports__